<template lang="html">
  <div class="send-exceptions">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('titleSendExceptions','titleSendExceptions') }}</h6>

          <div class="element-box">
            <div class="element-info">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <span class="os-icon os-icon-search2"></span>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('titleSendExceptionsSearch','titleSendExceptionsSearch') }}</h5>
                      <div class="element-inner-desc">{{ t('sendExceptionsSearchFormDesc','sendExceptionsSearchFormDesc') }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-md-4">
                  <i id="ruleToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                </div>
              </div>
            </div>
            <b-collapse v-model="visibleSearchBox" id="search" >
              <RulesSearch ref="searchBar" :isLoading="isLoading"/>
            </b-collapse>
          </div>
        </div>

        <div class="element-box">
          <div class="row justify-content-end">
            <!--
            <button class="btn btn-secondary ml-2" >{{t('exportThisPage', 'exportThisPage')}}</button>
            <button class="btn btn-secondary ml-2" >{{t('exportAllRules', 'exportAllRules')}}</button>
            -->
            <button class="btn btn-primary ml-2" @click="modalCreator({id: 'addRuleModal', title: t('addRuleModalHead','addRuleModalHead'), open: 'open'}, {}, $event.target)"  >{{ t('addRuleButtonText','addRuleButtonText') }}</button>
            <button class="btn btn-primary ml-2" disabled @click="modalCreator({id: 'importRulesModal', title: t('importRulesModalHead','importRulesModalHead'), open: 'open'}, {}, $event.target)" >{{ t('importRulesButtonText','importRulesButtonText') }}</button>
          </div>
          <div ref="response">
            <ResponseInfo v-if="getResponseInfo.responseName == 'sendExceptions'" class="mt-5"></ResponseInfo>
            <div v-if="getResponseInfo.responseName == 'sendExceptions'" class="col-12">
              <b-alert v-if="getResponseInfo.conflictId" variant="info" dismissible show fade @dismissed="clearResponse">
                <span>{{ t('conflictingRuleId', 'conflictingRuleId')}}</span>
                <span class="font-weight-bold">
                  #{{getResponseInfo.conflictId}}
                </span>
              </b-alert>
            </div>
          </div>
          <RulesAll/>
        </div>
      </div>

      <ModalAddRule/>
      <ModalImportRules/>
      <ModalEditRule/>
      <ModalDeleteRule/>
      <ModalRuleInfo/>
      <div v-if="this.modal['modalData'].open" class="modal-backdrop show"></div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import ResponseInfo from '@/components/ResponseInfo.vue'

import RulesSearch from '@/components/Send_Exceptions/RulesSearch.vue'
import RulesAll from '@/components/Send_Exceptions/RulesAll.vue'
import ModalAddRule from '@/components/Send_Exceptions/ModalAddRule.vue'
import ModalImportRules from '@/components/Send_Exceptions/ModalImportRules.vue'
import ModalEditRule from '@/components/Send_Exceptions/ModalEditRuleNew.vue'
import ModalDeleteRule from '@/components/Send_Exceptions/ModalDeleteRule.vue'
import ModalRuleInfo from '@/components/Send_Exceptions/ModalRuleInfo.vue'

export default {
  name: 'send_exceptions',
  provide() {
    return {
      modal: this.modal,
      modalCreator: this.modalCreator,
      resetModal: this.resetModal,
      refreshResults: this.refreshResults,
      clearResponse: this.clearResponse,
      hideModal: this.hideModal
    }
  },
  data() {
    return {
      visited: false,
      visibleSearchBox: true,
      isLoading: false,
      //Data storage for the modals
      modal: {
        modalData: {},
        ruleData: {},
        updateData: {}
      },
      searchSendExceptions: {
        page: 1,
        per_page: 20
      }
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo'])
  },
  methods: {
    clearResponse() {
      this.$store.dispatch('alertClearResponse')
    },
    //MODALS
    modalCreator(modalData, ruleData, button) {
      this.modal.modalData = modalData
      this.modal.ruleData = { ...ruleData }
      this.modal.updateData = {}

      this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
    },
    resetModal() {
      if(this.modal) {
        if(Object.prototype.toString.call(this.modal['modalData']) === '[object Object]') {
          Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
        } else {
          this.modal['modalData'].forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
        }

        if(Object.prototype.toString.call(this.modal['ruleData']) === '[object Object]') {
          Object.keys(this.modal['ruleData']).forEach((key) => (this.modal['ruleData'][key] = '' ))
        } else {
          this.modal['ruleData'].forEach((key) => (this.modal['ruleData'][key] = '' ))
        }

        if(Object.prototype.toString.call(this.modal['updateData']) === '[object Object]') {
          Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))
        } else {
          this.modal['updateData'].forEach((key) => (this.modal['updateData'][key] = '' ))
        }
      }
      
      this.$store.dispatch('alertClearResponse')
    },
    hideModal() {
      this.modal['modalData'].open = false
      this.$store.dispatch('alertClearResponse')
    },
    refreshResults(searchFrom = null) {
      let changeUrl = false

      if(searchFrom != null) {
        let searchType = searchFrom.searchFrom
        switch (searchType) {
          case 'searchBar':
            this.searchSendExceptions = searchFrom.searchData
            changeUrl = true
            break;
          case 'paginationNewPage':
            this.searchSendExceptions.page = searchFrom.searchData
            changeUrl = true
            break;
          case 'paginationPerPage':
            this.searchSendExceptions.per_page = searchFrom.searchData
            changeUrl = true
            break;
        }
      }

      if(Object.keys(this.$route.query).length && (!changeUrl)) {
          if(this.$route.query.page) {
            if(this.searchSendExceptions.page) {
              if(this.$route.query.page != this.searchSendExceptions.page) {
                this.searchSendExceptions.page = this.$route.query.page
              }
            } else {
              this.searchSendExceptions.page = this.$route.query.page
            }
          }

          if(this.$route.query.per_page) {
            if(this.searchSendExceptions.per_page) {
              if(this.$route.query.per_page != this.searchSendExceptions.per_page) {
                this.searchSendExceptions.per_page = this.$route.query.per_page
              }
            } else {
              this.searchSendExceptions.per_page = this.$route.query.per_page
            }
          }

          if(this.$route.query.ruleId) {
            if(this.searchSendExceptions.ruleId) {
              if(this.$route.query.ruleId != this.searchSendExceptions.ruleId) {
                this.searchSendExceptions.ruleId = this.$route.query.ruleId
              }
            } else {
              this.searchSendExceptions.ruleId = this.$route.query.ruleId
            }
          }

          if(this.$route.query.customerRef) {
            if(this.searchSendExceptions.customerRef) {
              if(this.$route.query.customerRef != this.searchSendExceptions.customerRef) {
                this.searchSendExceptions.customerRef = this.$route.query.customerRef
              }
            } else {
              this.searchSendExceptions.customerRef = this.$route.query.customerRef
            }
          }

          if(this.$route.query.accountNumber) {
            if(this.searchSendExceptions.accountNumber) {
              if(this.$route.query.accountNumber != this.searchSendExceptions.accountNumber) {
                this.searchSendExceptions.accountNumber = this.$route.query.accountNumber
              }
            } else {
              this.searchSendExceptions.accountNumber = this.$route.query.accountNumber
            }
          }

          if(this.$route.query.docReference) {
            if(this.searchSendExceptions.docReference) {
              if(this.$route.query.docReference != this.searchSendExceptions.docReference) {
                this.searchSendExceptions.docReference = this.$route.query.docReference
              }
            } else {
              this.searchSendExceptions.docReference = this.$route.query.docReference
            }
          }

          if(this.$route.query.documentType) {
            if(this.searchSendExceptions.documentType) {
              if(this.$route.query.documentType != this.searchSendExceptions.documentType) {
                this.searchSendExceptions.documentType = this.$route.query.documentType
              }
            } else {
              this.searchSendExceptions.documentType = this.$route.query.documentType
            }
          }

          if(this.$route.query.country) {
            if(this.searchSendExceptions.country) {
              if(this.$route.query.country != this.searchSendExceptions.country) {
                this.searchSendExceptions.country = this.$route.query.country
              }
            } else {
              this.searchSendExceptions.country = this.$route.query.country
            }
          }

          if(this.$route.query.entity) {
            if(this.searchSendExceptions.entity) {
              if(this.$route.query.entity != this.searchSendExceptions.entity) {
                this.searchSendExceptions.entity = this.$route.query.entity
              }
            } else {
              this.searchSendExceptions.entity = this.$route.query.entity
            }
          }

          if(this.$route.query.entityCode) {
            if(this.searchSendExceptions.entityCode) {
              if(this.$route.query.entityCode != this.searchSendExceptions.entityCode) {
                this.searchSendExceptions.entityCode = this.$route.query.entityCode
              }
            } else {
              this.searchSendExceptions.entityCode = this.$route.query.entityCode
            }
          }

          if(this.$route.query.batchType) {
            if(this.searchSendExceptions.batchType) {
              if(this.$route.query.batchType != this.searchSendExceptions.batchType) {
                this.searchSendExceptions.batchType = this.$route.query.batchType
              }
            } else {
              this.searchSendExceptions.batchType = this.$route.query.batchType
            }
          }

          if(this.$route.query.brand) {
            if(this.searchSendExceptions.brand) {
              if(this.$route.query.brand != this.searchSendExceptions.brand) {
                this.searchSendExceptions.brand = this.$route.query.brand
              }
            } else {
              this.searchSendExceptions.brand = this.$route.query.brand
            }
          }

          if(this.$route.query.docDuplicate) {
            if(this.searchSendExceptions.docDuplicate) {
              if(this.$route.query.docDuplicate != this.searchSendExceptions.docDuplicate) {
                this.searchSendExceptions.docDuplicate = this.$route.query.docDuplicate
              }
            } else {
              this.searchSendExceptions.docDuplicate = this.$route.query.docDuplicate
            }
          }

          if(this.$route.query.customerType) {
            if(this.searchSendExceptions.customerType) {
              if(this.$route.query.customerType != this.searchSendExceptions.customerType) {
                this.searchSendExceptions.customerType = this.$route.query.customerType
              }
            } else {
              this.searchSendExceptions.customerType = this.$route.query.customerType
            }
          }

          if(this.$route.query.documentValue) {
            if(this.searchSendExceptions.documentValue) {
              if(this.$route.query.documentValue != this.searchSendExceptions.documentValue) {
                this.searchSendExceptions.documentValue = this.$route.query.documentValue
              }
            } else {
              this.searchSendExceptions.documentValue = this.$route.query.documentValue
            }
          }

          if(this.$route.query.rule) {
            if(this.searchSendExceptions.rule) {
              if(this.$route.query.rule != this.searchSendExceptions.rule) {
                this.searchSendExceptions.rule = this.$route.query.rule
              }
            } else {
              this.searchSendExceptions.rule = this.$route.query.rule
            }
          }

          if(this.$route.query.enabled) {
            if(this.searchSendExceptions.enabled) {
              if(this.$route.query.enabled != this.searchSendExceptions.enabled) {
                this.searchSendExceptions.enabled = this.$route.query.enabled
              }
            } else {
              this.searchSendExceptions.enabled = this.$route.query.enabled
            }
          }
      }

      Object.keys(this.searchSendExceptions).forEach((key) => ((this.searchSendExceptions[key] == '') || (this.searchSendExceptions[key] == null)) && (this.searchSendExceptions[key] = undefined))
      if(changeUrl) {
        this.$router.push({ query: { ...this.$route.query, ...this.searchSendExceptions} })
      }
      this.$store.dispatch('sendExceptionsStore/getSendExceptions',{
        ...this.searchSendExceptions
      }).then(
        () => {
          changeUrl = false
        }
      )
    }
  },
  created() {
    if(Object.keys(this.$route.query).length) {
        //Pagination setup
        if(this.$route.query.page) {
          this.searchSendExceptions.page = parseInt(this.$route.query.page)
        } else {
          this.searchSendExceptions.page = 1
        }

        if(this.$route.query.per_page) {
          this.searchSendExceptions.per_page = parseInt(this.$route.query.per_page)
        } else {
          this.searchSendExceptions.per_page = 20
        }

        if(this.$route.query.ruleId) {
          this.searchSendExceptions.ruleId = this.$route.query.ruleId
        }

        if(this.$route.query.customerRef) {
          this.searchSendExceptions.customerRef = this.$route.query.customerRef
        }

        if(this.$route.query.accountNumber) {
          this.searchSendExceptions.accountNumber = this.$route.query.accountNumber
        }

        if(this.$route.query.docReference) {
          this.searchSendExceptions.docReference = this.$route.query.docReference
        }

        if(this.$route.query.documentType) {
          this.searchSendExceptions.documentType = this.$route.query.documentType
        }

        if(this.$route.query.country) {
          this.searchSendExceptions.country = this.$route.query.country
        }

        if(this.$route.query.entity) {
          this.searchSendExceptions.entity = this.$route.query.entity
        }

        if(this.$route.query.entityCode) {
          this.searchSendExceptions.entityCode = this.$route.query.entityCode
        }

        if(this.$route.query.batchType) {
          this.searchSendExceptions.batchType = this.$route.query.batchType
        }

        if(this.$route.query.brand) {
          this.searchSendExceptions.brand = this.$route.query.brand
        }

        if(this.$route.query.docDuplicate) {
          this.searchSendExceptions.docDuplicate = this.$route.query.docDuplicate
        }

        if(this.$route.query.customerType) {
          this.searchSendExceptions.customerType = this.$route.query.customerType
        }

        if(this.$route.query.documentValue) {
          this.searchSendExceptions.documentValue = this.$route.query.documentValue
        }

        if(this.$route.query.rule) {
          if(Array.isArray(this.$route.query.rule)) {
            this.searchSendExceptions.rule = this.$route.query.rule
          } else {
            this.searchSendExceptions.rule = [this.$route.query.rule]
          }
        }

        if(this.$route.query.enabled) {
          this.searchSendExceptions.enabled = this.$route.query.enabled
        }
    } else {
        this.searchSendExceptions.page = 1
        this.searchSendExceptions.per_page = 20
    }
    this.visited = true
    this.refreshResults()
  },
  components: {
    ResponseInfo,
    RulesSearch,
    RulesAll,
    ModalAddRule,
    ModalImportRules,
    ModalEditRule,
    ModalDeleteRule,
    ModalRuleInfo
  }
}
</script>

<style lang="css" scoped>
/*-----SEARCH BAR-----*/
.text-netsend-blue{
  color: #047bf8;
}
.rule-search-border{
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 10px;
}
#ruleToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}
#ruleToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.showhand{
  cursor: pointer;
}
</style>
